<template>
  <div>

  </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'
// import { parseNum } from '@/snippets/allSnippets'

export default {
  name: 'travelorderlist',
  props: [],
  data () {
    return {
      lang: {},
      langC: {},
      msg: '',
      documentName: '',
      documentName2: '',
      document: {},
      havePath: '',
      locCreatedAt: '',
      locUpdatedAt: '',
      locDocument: {},
      striped: false,
      bordered: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      comp: {},
      mainQuery: {},
      ana: {},
      empl:[],
      total: 0
    }
  },
  mounted () {


  },
  methods: {
    async print () {
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.BusinessYear = this.$store.state.businessYear
      }
      if (this.$store.state.language === 'EN') {
     //   this.lang = {...langEn}
        this.langC = {...commEn}
      }
      if (this.$store.state.language === 'HR') {
       // this.lang = {...langHr}
        this.langC = {...commHr}
      }
      this.printDoc()
    },

    formatPrice (value) {
      if (this.$store.state.language === 'EN') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      if (this.$store.state.language === 'HR') {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatPriceHR (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
     addLineDash () {
      const docPart = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 550,
                y2: 0,
                lineWidth: 1,
                dash: { length: 1 },
              }
            ]
          }
      this.content.push(docPart)
    },
    printDoc () {
      this.comp = this.$store.state.companyActiv
      this.ana = this.$store.state.printObj ? this.$store.state.printObj : {}
      console.log('this.ana ', this.ana)

      this.initDocument()
      this.addHead()
      this.addLine()
      this.addItemHead()
      this.addLine()
      // map array 
      // new page, not first time 
      if (this.ana.head1) {
        this.ana.head1.map(item => {
          this.addItem(item)
          this.total += item.Iznos
        })
      }
      this.addLine()
      this.addFooter()

      this.docDefinition.content = this.content
      pdfMake.createPdf(this.docDefinition).open()
    },
    initDocument () {
      //pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.addVirtualFileSystem(pdfFonts);
      this.docDefinition = {}
      this.docDefinition.pageSize = 'A4'
      this.docDefinition.pageOrientation = 'portrait'
      this.docDefinition.pageMargins = [ 20, 20, 20, 40 ]
      this.content = []
    },
    skipNewPage() {
      const docPart01 = {
      columns: [
          {
            width: '40%',
            fontSize: 7,
            bold: true,
            alignment: 'left',
            text: '  ',
            pageBreak: 'after'
          },
        ]
      }
      this.content.push(docPart01)
    },
  
    addEmptyRow () {
      const docPart = {
            columns: [
              {
                width: '20%',
                text: [
                  { text: ' \n ', fontSize: 8 }
                ]
              },
              {
                width: '60%',
                text: [
                  { text: ' ', fontSize: 8 }
                ]
              }
            ]
          }
      this.content.push(docPart)
    },
    addLine () {
      const docPart = {
            canvas: [
              {
                type: 'line',
                x1: 0,
                y1: 0,
                x2: 550,
                y2: 0,
                lineWidth: 1
              }
            ]
          }
      this.content.push(docPart)
    },
    addHead() {
      const docPart = {
          columns: [
            {
              // % width
              width: '30%',
              text: [
                { text: this.comp.CompanyName + ' \n', fontSize: 10, bold: true },
                { text: (this.comp.CompanyStreet ? this.comp.CompanyStreet : ' ') + ' ' + (this.comp.CompanyBuildingNameNumber ? this.comp.CompanyBuildingNameNumber : ' ') + ' \n', fontSize: 8 },
                { text: (this.comp.CompanyPostcode ? this.comp.CompanyPostcode : ' ') + ' ' + (this.comp.CompanyCity ? this.comp.CompanyCity : ' ') + ' \n', fontSize: 8 },
                { text: (this.comp.Companyemail ? 'email:' +  this.comp.Companyemail + ' \n' : ' ') , fontSize: 8 },
                { text: 'OIB:' + (this.comp.CompanyVATID ? this.comp.CompanyVATID : ' '), fontSize: 8 }
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '45%',
              text: [
                { text: 'Lista naloga za službeno putovanje \n', fontSize: 18, bold: true, alignment: 'center' },
                { text: 'za ' + (this.$store.state.businessYear ? this.$store.state.businessYear : 2023), fontSize: 12, bold: true, alignment: 'center'  },
                { text: (this.ana.head3 ? this.ana.head3 + ' \n' : ''), fontSize: 8, bold: true },
                { text: (this.ana.head4 ? this.ana.head4 + ' \n' : ''), fontSize: 8, bold: true },
                { text: (this.ana.head5 ? this.ana.head5 + ' \n' : ''), fontSize: 8, bold: true },
              ]
            },
            {
              // % width
              width: '20%',
              text: [                 
                { text: ' Datum ispisa: ' + dayjs().format('DD.MM.YYYY, h:mm:ss a'), fontSize:8}
              ]   
            }
          ],
          // optional space between columns
          columnGap: 10
        }
        this.content.push(docPart)
    },
    addItemHead() {
      const docPart = {
          columns: [
            {
              // % width
              width: '5%',
              text: [
                { text: 'Broj naloga\n', fontSize: 7 },
              ]
            },
            {
              // % width
              width: '10%',
              text: [
                { text:  'Datum Naloga \n', fontSize: 7 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '15%',
              text: [
                { text: 'Ime i Prezime\n', fontSize: 7 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: 'Na službeno putovanje\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: 'Sa zadatkom\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: 'Odobrio:\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: 'Ukupno\n', fontSize: 8, alignment: 'right' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: 'Predujam putnih troš.\n', fontSize: 8, alignment: 'right' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '8%',
              text: [
                { text: 'Za isplatu/povrat\n', fontSize: 8, alignment: 'center' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '8%',
              text: [
                { text: 'Završen\n', fontSize: 8, alignment: 'center' },
              ]
            }
          ],
          // optional space between columns
          columnGap: 10
        }
        this.content.push(docPart)
    },

    addItem(item) {
      const docPart = {
          columns: [
            {
              // % width
              width: '5%',
              text: [
                { text: (item.TravelOrderId ? item.TravelOrderId : ' ') + ' \n', fontSize: 8 },
              ]
            },
            {
              // % width
              width: '10%',
              text: [
                { text: (item.OrderDate ? dayjs(item.OrderDate).format('DD.MM.YYYY')  : ' ') + ' \n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '15%',
              text: [
                { text: (item.eFirst ? item.eFirst + ' ' : '') + (item.eLast ? item.eLast + ' ' : '') + '\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: (item.TravelTo ? item.TravelTo + ' ' : '') + '\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: (item.TravelTask ? item.TravelTask + ' ' : '') + '\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: (item.ApprovedByemail ? item.ApprovedByemail + ' ' : '') + '\n', fontSize: 8 },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: (item.FinTotalKn ? this.formatPrice(item.FinTotalKn) + ' ' : '') + '\n', fontSize: 8, alignment: 'right' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '10%',
              text: [
                { text: (item.ExpensesForwardHomeC ? this.formatPrice(item.ExpensesForwardHomeC) + ' ' : '') + '\n', fontSize: 8, alignment: 'right' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '8%',
              text: [
                { text: (item.FinPayReturnKn ? this.formatPrice(item.FinPayReturnKn) + ' ' : '') + '\n', fontSize: 8, alignment: 'right' },
              ]
            },
            {
              // auto-sized columns have their widths based on their content
              width: '8%',
              text: [
                { text: (item.Finished ? 'Da' : 'Ne')+ '\n', fontSize: 8, alignment: 'center' },
              ]
            }
          ],
          // optional space between columns
          columnGap: 10
        }
        this.content.push(docPart)
    },
    addFooter() {
      const docPart = {
          columns: [
            {
              // % width
              width: '38%',
              text: [
                { text: ' \n', fontSize: 8, bold: true },
              ]
            }
          ],
          // optional space between columns
          columnGap: 10
        }
        this.content.push(docPart)
    },

    addSignature () {
      const docPart = {
        columns: [
              {
                width: '5%',
                text: ' '
              },
              {
                width: '25%',
                text: [
                  { text: ' \n', fontSize: 10 },
                  { text: '____________________ \n', fontSize: 8, alignment: 'center' }
                ]
              },
              {
                width: '25%',
                text: ' '
              },
              {
                width: '25%',
                text: [
                  { text: ' \n', fontSize: 10 },
                  { text: '____________________  \n', fontSize: 8, alignment: 'center' }
                ]
              }
            ]
          }
      this.content.push(docPart)
    },

    addEmpty () {
      const docPart = {
        
          }
      this.content.push(docPart)
    },

  },
  computed: {
  },
  watch: {
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slide-fade-enter-active {
  transition: all 1.3s ease;
}
.slide-fade-leave-active {
  transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
